import axios from 'axios';

const setupAxios = () => {
	axios.defaults.baseUrl = '';
};

export default setupAxios;



// WEBPACK FOOTER //
// ./src/config/axios.js